module.exports = __webpack_public_path__ + "static/media/new_logo.1fee039f.svg";